export default "__VITE_ASSET__CEmhHep8__"